import { render, staticRenderFns } from "./ManageCustomerEdit.vue?vue&type=template&id=03751270&"
import script from "./ManageCustomerEdit.vue?vue&type=script&lang=js&"
export * from "./ManageCustomerEdit.vue?vue&type=script&lang=js&"
import style0 from "./ManageCustomerEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ManageCustomerEdit.vue"
export default component.exports